import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "../../layouts/Header";
import Toaster from "../../components/ui/toaster";
import MakeDonationParent from "../../components/MakeDonationParent";
export default function SettingsMakeDonation() {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state.donation || "";
  return (
    <>
      {" "}
      <Header />
      <div className="min-h-screen w-full bg-gray-100 flex flex-col">
        {/* Top Gradient Bar */}
        <div className="h-14 bg-gradient-to-r from-blue-600 to-purple-600 flex items-center pl-20 text-white">
          <ArrowLeft
            className="mr-5 bg-transparent rounded-full p-1 border-gray-200/60 border hover:border-gray-400 hover:bg-white/20"
            onClick={() => {
              navigate("/settings/donations-view", {
                state: {
                  donation: data,
                },
              });
            }}
          />
          <p className="text-sm font-medium underline mr-2">Settings</p>
          <p className="text-sm font-medium">
            {" "}
            / Donations / {data?.organisation_info?.org_name} / Make a donation
          </p>
        </div>
        <Toaster />
        <MakeDonationParent data={data} />
      </div>
    </>
  );
}
